import styled from "styled-components";
import Text from "@streeteasy/design-system/deprecated/Text";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";

export const TooltipWrapper = styled(Tooltip)`
  align-self: flex-end;
  left: 5px;
`;

export const TooltipText = styled(Text)`
  margin: 15px 0;
  width: 238px;
`;
